var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list',_vm._l((_vm.items),function(item){return _c('v-list-item',{key:item,attrs:{"title":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }